import { ApiConfiguration } from "../api/ApiConfiguration";
export function resolveImageUrl(value?: string|null): string|undefined {
 if(!value?.trim())return undefined;
 try {const url=new URL(value.trim(),ApiConfiguration.baseUrl.replace(/\/+$/,"")+"/");return ["http:","https:","blob:","data:"].includes(url.protocol)?url.href:undefined;}catch{return undefined;}
}
